<template>
	<div class="secondary-menu create-event" v-if="spotOriginal">
		<div class="secondary-menu-header">
		  	<i class="back" @click="openEvent(spotOriginal.id, 'spot')"></i>
		  	<div class="title">{{ trans('edit') }}</div>
		  	<i class="trash" @click="removeSpot(spot.id)"></i>
		</div>
		<div class="secondary-menu-body" id="scroll-event">
		  	<div class="tab-content-wrapper event-category-tabs bang">
				<div class="tab-content-inner">
					<div class="tab-content">
						<div>
							<form novalidate data-vv-scope="form1" @submit.prevent>
								<div class="center event-form">
                  <input type="hidden" name="type" v-model="type" v-validate="{required: true}" />
                  <div class="row">
                    <div class="small-12 form-error text-center" :class="{'is-visible': errors.has('form1.type')}">
                      {{ trans('events.type.required') }}
                    </div>
                  </div>
									<div class="name-edit">
										<label>
										  	<input type="text" v-bind:placeholder="trans('title')" maxlength="50" v-bind:data-vv-as="trans('title')" :required="titleRequired" v-model="title" v-validate="{required: titleRequired}" :class="{'is-invalid-input': errors.has('form1.title')}" name="title">

										  	<span class="form-error" :class="{'is-visible': errors.has('form1.title')}">
												{{ errors.first('form1.title') }}
											</span>
										</label>
									</div>
									<div class="box add-margin">

                    <div id="event-main-pic" class="profile-main-pic" @click.self="openGallery('clear', true)" :data-photo="photo_small">
                      <div class="img" v-if="!photo_small.match(/default_180x180/)"
                           :style="{'background': photo_small}">
                      </div>
                      <div v-if="!photo_small.match(/default_180x180/)"
                           @click.stop="clearAvatar('clear', true)" class="close">
                      </div>
                    </div>
									</div>

									<template v-if="type === 'guide' || type === 'fun'">
				            <VideoGallery/>
				          </template>
                  <PhotoGallery ref="PhotoGallery"/>

									<div class="box description-link">

                    <div class="row">
                      <div class="headline">{{trans('club_description')}}</div>
                      <textarea class="description" rows="1" placeholder="What do you want to do?" v-model="description"></textarea>
                      <span class="form-error" :class="{'is-visible': errors.has('form1.description')}">
												    {{ errors.first('form1.description') }}
											    </span>
                    </div>

                    <div class="box spot_tags">
                      <div class="headline">{{ trans('Select up to 3 tags') }}</div>
                      <div :class="{'active':active_spot_tags.indexOf(spot_tag.id) !== -1}" @click="toggleSpotTag(spot_tag.id)" v-for="spot_tag in spot_tags" class="spot_tags-item">
                        {{spot_tag.name}}
                      </div>
                      <span class="form-error" :class="{'is-visible': errors.has('form1.active_spot_tags')}">
                            {{ errors.first('form1.active_spot_tags') }}
                         </span>
                    </div>
                    <div class="website">
                      <span class="website-icon"></span>
                      <label>
                        <input type="text" placeholder="web address" v-bind:data-vv-as="trans('website')" v-model="public_url" v-validate="{max: 750}" :class="{'is-invalid-input': errors.has('form1.public_url')}" name="public_url">

                        <span class="form-error" :class="{'is-visible': errors.has('form1.public_url')}">
								            {{ errors.first('form1.public_url') }}
							         </span>
                      </label>
                    </div>
									</div>
									<div class="box">
										<div class="row">
										  	<div class="title">{{ trans('location') }}</div>
										  	<div class="options">
											 	<button id="gps" class="btn"
													:class="{'darker': manualLocationSet}"
													@click="chooseGps"
													type="button">
													{{ trans('reg.gps') }}
											 	</button>
											 	<button id="map" class="btn"
													:class="{'darker': !manualLocationSet}"
													@click="chooseMap"
													type="button">
													{{ trans('reg.map') }}
											 	</button>
										  	</div>
										  	<div class="detail location notranslate" v-if="(addressShow || addressError) && type !== 'guide'">{{ addressShow }}
										  		<span class="form-error" :class="{'is-visible': addressError}">
														{{ addressError }}
													</span>
										  	</div>
										</div>
									</div>
<!--                  <div class="detail location notranslate" v-if="addressShow">
                    {{ addressShow }}
                    <span class="form-error" :class="{'is-visible': addressError}">
                      {{ addressError }}
                    </span>
                  </div>-->
									<div id="map-box" class="address" v-if="mapVisible" :class="{'show': mapVisible, 'no-address': !addressShow}">
										<div class="input-wrapper">
										  	<label>
											 	<input
                            v-show="mapVisible"
												  	class="form-control"
												  	type="text"
												  	name="address"
												  	:placeholder="trans('event_address')"
												  	:data-vv-as="trans('address')"
												  	v-model="address"
                            @click="mapVisible = true"
												  	v-validate="'required'"
												  	:class="{'is-invalid-input': errors.has('form1.address')}"
												  	@input="handleAddressModification"
												  	required/>
										  	</label>
										</div>
										<div v-show="mapVisible" class="map-box" :style="{'height':  '450px'}">
										  	<Map
												:lat="lat"
												:lng="lng"
												:zoom="15"
                        ref="eventMap"
												:styles="mapHeight"
												:clickable="true"
												:draggable="true"
                        :options="mapOptions"
												:dragEnd="handleMapMarkerDrag"/>
										  	<div class="float-button">
											 	  <button type="button" class="btn set-location" @click="setLocation">{{ trans('set_location') }}</button>
										  	</div>
										</div>
									</div>
									<button class="btn publish" id="button6" type="button" @click="updateSpot">
										{{ trans('save') }}
									</button>
								</div>
							</form>
						</div>
					</div>
			 	</div>
		  	</div>
		</div>
	</div>
</template>

<script>
	 import {mapGetters} from 'vuex';
	 import DatePickerComponent from '@buddy/views/widgets/DatePickerComponent.vue';
	 import eventsModule from "@events/module/store/type";
	 import PhotoSlider from '@events/views/widgets/event/create/media/PhotoSlider.vue'
   import VideoSlider from '@events/views/widgets/event/create/media/VideoSlider.vue'
   import PhotoGallery from '@events/views/widgets/event/create/media/PhotoGallery.vue'
   import VideoGallery from '@events/views/widgets/event/create/media/VideoGallery.vue'
	 import Map from '@buddy/views/widgets/Map.vue';
	 import moment from "moment";
   import TimePickerComponent from "@buddy/views/widgets/TimePickerComponent.vue";

   import { VueEditor, Quill } from "vue2-editor";
   import _ from "lodash";
   import Vue from "vue";

	 export default {
		  mixins: [
				require('@general/lib/mixin').default,
				require('@general/lib/mixin-events').default,
				require('@general/lib/mixin-event-edit').default,
		  ],
		  data() {
            return {
                active_spot_tags: [],
                id: null,
                title: '',
                event_date: '', //this needs moment globally for vee-validate to work
                time: '',
                description: ``,
                location: '',
                photo_small: '',
                address_type: 'full_address',
                address: '',
                addressShow: '',
                addressError: false,
                tags: [],
                newTag: "",
                type: null,
                chemsfriendly: false,
                is_profile_linked: false,

                lat: 52.520389,
                lng: 13.40424,

                locality: 'Berlin',
                state: 'Berlin',
                country: 'Germany',
                country_code: 'DE',

                public_url : '',
                venue: '',
                name: '',
                contact: '',
                note: '',

                //inner components variables
                mapVisible: null,
                mapFirstTime: true,
                //selected photos for event
                selectedPhotos: [],
                selectedVideos: [],
                deletedPhotos: [],
                deletedVideos: [],
                defaultEventPhoto: 'url("/assets/img/default_180x180.jpg") center / cover',
                photos: [],

                //slim
                croppers: [],
                editPhotoId: null,
                slimOptions: this.defaultSlimOptions(),
                preview_photo: [],
                date: 'today',
                manualLocationSet: false,
                customToolbar: [
                  ["bold", "italic", "underline"],
                  [{ list: "ordered" }, { list: "bullet" }]
                ],
                descriptionMaxLength: 3000
            }
        },
		  components: {
            Map,
            DatePickerComponent,
            PhotoGallery,
            VideoGallery,
            PhotoSlider,
            VideoSlider,
            TimePickerComponent,
            VueEditor
		  },
		  computed: {
        mapHeight() {
            return '450px';
        },
        mapOptions() {
            return {
              scrollWheelZoom: false,
              dragging: true,
              touchZoom: true
            }
        },
				spotOriginal(){
					 return this.$store.getters.getSpot(this.spotData.id)
				},
        textAreaDescription() {
            return (this.type === 'fun' || this.type === 'bang') ? this.trans('event_description') : 'What do you want to do?';
        },
				...mapGetters({
					 spotData: eventsModule.getters.spot,
            spot_tags: 'spotTags',
				}),
        activePhotosCount() {
          return this.selectedPhotos.length;
        },
        activeVideosCount() {
          return this.selectedVideos.length;
        },
        leftPublicPhotosCount() {
          const maxAmount = app.maxPublicPicturesAmount;
          const publicPhotos = this.selectedPhotos;
          return (publicPhotos.length >= maxAmount) ? 0 : (maxAmount-publicPhotos.length);
        },
        titleRequired() {
          return this.type !== 'bang';
        }
		  },
		  mounted() {
              console.log('[Edit Event desktop] Mounted', {
                  spotId: this.spotData.id,
                  event: this.spot,
              })
              //this.$store.dispatch(eventsModule.actions.spot.loadInfo, {id: this.spotData.id, edit : 1}).then(() => {
                //this.loadEventInfo();
              //})
              this.loadEventInfo();
        },
        methods: {
          toggleSpotTag(id){
            if(this.active_spot_tags.indexOf(id) === -1){
              if( this.active_spot_tags.length < 3){
                this.active_spot_tags.push(id)
              }
            }else{
              this.active_spot_tags.splice(this.active_spot_tags.indexOf(id), 1);
            }
          },
            loadEventInfo(){
                let self = this;
                if (!!self.spotOriginal) {
                  if (!self.isMyEvent(self.spotOriginal)) {
                    //self.goTo(`/spot/${self.eventId}`)
                    return
                  }

                  self.spot = _.cloneDeep(self.spotOriginal)

                  console.log('spotOriginal', self.spotOriginal);
                  self.prepareData(self.spotOriginal);
                }
            },
            fixDescription() {
              let v = this

              document.getElementById('scroll-event').addEventListener('scroll', function () {
                let container, editor;

                v.$nextTick(() => {
                  editor = v.$refs.vueEditor;
                  container = editor.$refs.quillContainer;

                  container.childNodes[0].className += ' disable-overflow';
                })


                this.timer = setTimeout(() => {
                  container.childNodes[0].classList.remove('disable-overflow')
                }, 100)
              });
            },
            setSelectedPhotos(photos) {
              for (let key in photos) {
                this.selectedPhotos.push(photos[key])
                let index = _.findIndex(this.deletedPhotos, (e) => {
                    return e === photos[key].id;
                })
                if (index !== -1) {
                    this.deletedPhotos.splice(index, 1);
                }
              }
            },
            setVideos(videos) {
              for (let key in videos) {
                this.selectedVideos.push(videos[key])
              }
            },

          prepareData(data){
            const self = this;
            for (let key in data) {
              if(key === 'spot_tags'){
                this.active_spot_tags = data[key].map( el => el.id );
              }else if(key === 'photo_small') {
                this[key] = 'url("'+data[key]+'")  center / cover';
              }else{
                if (key === 'address') {
                  this.addressShow = data[key];
                }

                this[key] = data[key];
              }
            }
          },
          defaultEventBackground(data) {
            if (data) {
              let photo = data[0];
              this.photo_small = `url(${photo.photo_small}) center / cover`
              this.photo_id = photo.id;
            }
          },
          setLocation() {
            this.mapVisible = false;
            this.manualLocationSet = true;
            this.addressShow = this.address;
          },
          setPhotos(data) {
	            this.photos.push(data);
              this.selectedPhotos.push(data.id);
          },
          setDeletePhotos(data, index) {
            this.deletedPhotos.push(data.id);
            this.selectedPhotos.splice(index, 1);
            data.active = false;

            if (this.$refs.PhotoGallery.photos !== null) {
              this.$refs.PhotoGallery.photos.push(data)
            } else {
              this.$refs.PhotoGallery.photos = []
            }
          },
          setDeleteVideos(data, index) {
            this.deletedVideos.push(data.id);
            this.selectedVideos.splice(index, 1);
          },
          checkDeletePhoto(photoId) {
            const filterId = this.deletedPhotos.filter((filter) => {
              return filter === photoId;
            });

            if (filterId) {
              this.removeByValue(this.deletedPhotos, photoId);
            }
          },
          addTag() {
              this.newTag = this.newTag.replace(/[^A-Za-z0-9_]/g, '')
              if (this.newTag && !this.tags.includes(this.newTag)) {
                let arrayTag = {name: this.newTag};
                this.tags.push(arrayTag)
              }

              this.newTag = ''
          },
          deleteTag(tag) {
            const index = this.tags.indexOf(tag);

            this.tags.splice(index, 1);
          },

          clearAvatar(slot) {
            app.$emit('avatar-preloader', { slot, value: true })
            this.photo_small = 'url("/assets/img/default_180x180.jpg") center / cover';
            //this.preview_photo = [];

            app.$emit('avatar-preloader', { slot, value: false })
          },
          setType(type) {
            if (this.type !== type) {
              return;
            }
            this.type = type
            if (type !== 'fun') {
              this.chemsfriendly = false
            }
          },
          openGallery(slot, defaultImg = false) {
            app.$emit('show-photo-event-gallery', slot, defaultImg)
          },
          chooseMap() {
            this.mapVisible = true
            this.manualLocationSet = true
            this.addressError = null
            this.$nextTick(() => {
              if (this.isMobile) {
                document.getElementById('map-box').scrollIntoView();
              } else {
                const scrollDiv = document.getElementById('scroll-event');
                const mapBox = document.getElementById('map-box');
                const coordinates = scrollDiv.scrollHeight - mapBox.offsetHeight;

                scrollDiv.scroll({
                  top: coordinates,
                });
              }
            });
          },
          async chooseGps() {
            this.mapVisible = false
            this.manualLocationSet = false
            this.addressError = null
            let lat, lng, address;
            try {
              ({lat, lng, address} = await this.getCurrentPositionAndAddress(true))
              this.lat = lat
              this.lng = lng
              this.address = address.formattedAddress
              this.locality = address.locality
              this.state = address.state
              this.country = address.country
              this.country_code = address.country_code
              this.addressError = null
            } catch (e) {
              this.addressError = this.trans('fail_auto_choose_manual_location')
              this.chooseMap()
            }
          },
          async handleMapMarkerDrag(event) {
            let newLat, newLng;

            if (this.mapProviderIsGmap) {
              newLat = event.latLng.lat();
              newLng = event.latLng.lng();
            } else {
              newLat = event.target.getLatLng().lat;
              newLng = event.target.getLatLng().lng;
            }

            try {
              let fullInfo = await this.getAddressForLatLng(newLat, newLng, true);
              this.lat = newLat;
              this.lng = newLng;
              this.location_type = 'manual';
              this.address = fullInfo.formattedAddress;
              this.locality = fullInfo.locality;
              this.state = fullInfo.state;
              this.country = fullInfo.country;
              this.country_code = fullInfo.country_code;
              this.addressError = null
            } catch(e) {
              this.addressError = e
            }
          },
          handleAddressModification: _.debounce(async function (event){
            let lat, lng;
            console.log('Change address',event.target.value)
            if (!event.target.value) {
              return;
            }

            try {
              //update map marker
              this.addressShow = 'Location defining...';
              let fullInfo = await this.getLatLngForAddress(this.address, true);
              this.addressShow = this.address;
              ({lat, lng} = fullInfo.point);
              this.lat = parseFloat(lat);
              this.lng = parseFloat(lng);
              this.location_type = 'manual';
              this.locality = fullInfo.locality;
              this.state = fullInfo.state;
              this.country = fullInfo.country;
              this.country_code = fullInfo.country_code;
              let v = this
              setTimeout(function() {
                v.zoom = 15
              }, 500)
              this.addressError = null
            } catch(e) {
              this.addressError = e
            }
          }, 1000),
          removeByValue(arr) {
            let what, a = arguments, length = a.length, ax;
            while (length > 1 && arr.length) {
              what = a[--length];
              while ((ax = arr.indexOf(what)) !== -1) {
                arr.splice(ax, 1);
              }
            }
            return arr;
          },
          async updateSpot() {
            this.$validator.validate();

            let spot = _.pick(this, [
              'id', 'title', 'description', 'location', 'locality', 'state',
              'country', 'country_code', 'address', 'lat', 'lng', 'address_type',
              'public_url','photo_id', 'active_spot_tags', 'spot_tags'
            ])

            this.showLoadingButton('#button6')

            this.saveSpot(spot)
                .then((data) => {
                  this.errors.remove('form1.active_spot_tags')
                  this.$store.dispatch(eventsModule.actions.setSpot, { visible: false })
                  this.restoreLoadingButton('#button6')
                  this.$store.commit(eventsModule.mutations.spots.updateSpot, data)

                }).catch(() => {
              let self = this;
              this.errors.remove('form1.active_spot_tags')
              $.each(e.data.errors,function(key,val){
                self.errors.add({
                  field: 'form1.'+key,
                  msg: val[0]
                })
              })
              this.restoreLoadingButton('#button6')
            })
          },
          setDate(dateType) {
	            if (dateType === 'today') {
                  this.date = 'today';
                  this.event_date = moment().format('YYYY-MM-DD')
              } else if (dateType === 'tomorrow') {
                  this.date = 'tomorrow';
                  this.event_date = moment().add(1, 'day').format('YYYY-MM-DD')
              }
          }
        }
	 }
</script>
